import { render, staticRenderFns } from "./relive-or-binding.vue?vue&type=template&id=f25e5558&scoped=true&lang=pug"
import script from "./relive-or-binding.vue?vue&type=script&lang=js"
export * from "./relive-or-binding.vue?vue&type=script&lang=js"
import style0 from "./relive-or-binding.vue?vue&type=style&index=0&id=f25e5558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25e5558",
  null
  
)

export default component.exports